import { labelService } from '@/utils/labels';

export const labelMixin = {
	computed: {
		labels() {
			const tenantId = this.tenantId || this.$route?.query?.tid || process.env.VUE_APP_DEFAULT_TENANT_ID;
			return labelService.getLabels(tenantId);
		},

		tenantId() {
			return this.$route?.query?.tid || process.env.VUE_APP_DEFAULT_TENANT_ID;
		},
	},

	methods: {
		getLabel(labelKey, defaultValue = '') {
			return labelService.getLabel(this.tenantId, labelKey, defaultValue);
		},

		formatLabel(labelKey, replacements = {}, defaultValue = '') {
			const label = this.getLabel(labelKey, defaultValue);
			return labelService.formatLabel(label, replacements);
		},
	},
};
